import { Heart, Mic, BookOpen, GraduationCap } from "lucide-react";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative bg-[#050505] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-14">
        {/* Left: image stack */}
        <div className="lg:col-span-5">
          <div className="relative">
            <img
              src="/images/gary-cream-blazer.jpg"
              alt="Gary Zelesky in cream blazer and pink shirt"
              className="w-full h-[640px] object-contain bg-[#EC1985]"
            />
            <div className="absolute -bottom-6 -right-6 bg-[#EC1985] text-white p-6 max-w-[260px] hidden md:block">
              <div className="font-display text-3xl leading-none">"The Human Defibrillator"</div>
              <div className="mt-2 text-xs uppercase tracking-[0.2em]">— Audience Coined</div>
            </div>
          </div>
        </div>

        {/* Right: copy */}
        <div className="lg:col-span-7 lg:pl-8">
          <div className="flex items-center gap-3 mb-6">
            <span className="section-num">01 / ABOUT</span>
            <div className="divider-red" />
          </div>
          <h2 data-testid="about-heading" className="h-display text-5xl md:text-6xl lg:text-7xl text-white">
            Not just <span className="text-[#EC1985]">motivation.</span><br />
            A jumpstart for <br />the life you were created to live.
          </h2>

          <div className="mt-10 space-y-5 text-white/80 text-lg leading-relaxed max-w-2xl">
            <p>
              Gary Zelesky is a nationally recognized keynote speaker, author and executive leadership voice
              whose message has impacted more than one million people live over the past 30+ years. Known as <span className="text-white font-bold">"The Human Defibrillator"</span> — and called an <span className="text-white font-bold italic">"edutainer"</span> by the University of the Pacific's Arthur A. Dugoni School of Dentistry — he is a <span className="text-white font-bold">re-engagement expert</span> who helps organizations move beyond burnout, routine, resistance, and disconnection into renewed energy and ownership.
            </p>
            <p>
              With a Master's in Executive Leadership from William Jessup University, and a story that includes surviving a heart attack and major health challenges, Gary doesn't speak about resilience as theory — he speaks it as lived experience. The result is a rare blend of humor, storytelling, and practical insight that audiences from MasterCard to Hinman keep inviting back.
            </p>
          </div>

          <div className="mt-12 grid grid-cols-2 gap-4">
            {[
              { icon: Mic, label: "Keynote Speaker" },
              { icon: BookOpen, label: "Author of 3 Books" },
              { icon: Heart, label: "Heart Attack Survivor" },
              { icon: GraduationCap, label: "M.A. Executive Leadership" },
            ].map(({ icon: Icon, label }) => (
              <div
                key={label}
                className="surface p-5 flex items-center gap-3 hover:border-[#EC1985] transition-colors"
              >
                <Icon size={22} className="text-[#EC1985]" />
                <span className="text-sm font-bold uppercase tracking-[0.1em]">{label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
